import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerRemoveOtherCostsFromContractChangeGql } from '../AgreementsQueries';

export const useRemoveAgreementsOther = (
    contractChangeId: number,
    checkedIds: number[],
    refreshAgreementsOther: () => void,
    refreshFilters: () => void,
) => {
    const dispatch = useDispatch();

    const [
        removeOtherCostsData,
        removeOtherCostsStatus,
        removeOtherCostsError,
        removeOtherCostsRequest,
        removeOtherCostsSetData,
    ] = useRequest({
        requestId: 'removeOtherCostsChange',
        query: uerRemoveOtherCostsFromContractChangeGql,
        withEffect: false,
    });

    const handleRemoveOtherCosts = useCallback(() => {
        dispatch(removeOtherCostsRequest({ contractChangeId, contractOtherCostIds: checkedIds }));
    }, [checkedIds, contractChangeId, dispatch, removeOtherCostsRequest]);

    useEffect(() => {
        if (
            removeOtherCostsStatus === RequestStatus.SUCCESS &&
            removeOtherCostsData?.uerRemoveOtherCostsFromContractChange?.result
        ) {
            refreshAgreementsOther();
            refreshFilters();
        }
    }, [
        refreshAgreementsOther,
        refreshFilters,
        removeOtherCostsData?.uerRemoveOtherCostsFromContractChange?.result,
        removeOtherCostsStatus,
    ]);

    return {
        removeOtherCostsData: removeOtherCostsData?.uerRemoveOtherCostsFromContractChange,
        removeOtherCostsStatus,
        removeOtherCostsError,
        removeOtherCostsSetData,
        handleRemoveOtherCosts,
    };
};
